import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'

/**
 * Gates the new repo-issues sidebar/header layout on both flags:
 *
 * - `repo_issues_sidebar_layout` (current_user-scoped) toggles the layout itself.
 * - `issue_pinned_views` (actor-aware via `PinnedViewsFeature`) toggles the IA
 *   the lifted header assumes. `useFeatureFlag` is required so the actor-aware
 *   evaluation flows through `AppPayloadContext`; `isFeatureEnabled` would only
 *   see `current_user`.
 */
export function useRepoIssuesSidebarLayoutEnabled(): boolean {
  // eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags -- issue_pinned_views uses actor-aware server-side evaluation via PinnedViewsFeature.
  const pinnedViewsEnabled = useFeatureFlag('issue_pinned_views')
  return pinnedViewsEnabled && isFeatureEnabled('repo_issues_sidebar_layout')
}
